import { Component, type ComponentChildren, type VNode } from 'preact';

interface Props { fallback: VNode; children: ComponentChildren }
interface State { hasError: boolean }

export class ErrorBoundary extends Component<Props, State> {
  override state = { hasError: false };

  static override getDerivedStateFromError(): State { return { hasError: true }; }

  override componentDidCatch(error: unknown, info: unknown): void {
    console.error('[ErrorBoundary] caught', error, info);
  }

  override render() {
    if (this.state.hasError) return this.props.fallback;
    return this.props.children as VNode;
  }
}
